export default __webpack_public_path__ + "images/pause-f23e8a6efaedf2f27e0d15a243d0d7f9.svg";